import * as React from "react";
import ArrowLeft from "kanopi-components/icons/ArrowLeft";
import { Button, SHAPE, SIZE } from "baseui/button";

type TButtonProps = React.ComponentProps<typeof Button>;

export const BackButton = (props: TButtonProps) => (
  <Button
    kind="tertiary"
    shape={SHAPE.square}
    size={SIZE.compact}
    aria-label="Previous question"
    data-testid="backButton"
    {...props}
  >
    <ArrowLeft title="Previous question" size={24} />
  </Button>
);
